export function resolveWorkspaceRedirectPath(
  requestedWorkspaceId: number,
  fallbackWorkspaceId: number,
  pathname: string,
): string {
  const marker = `/workspace/${requestedWorkspaceId}`;
  const suffix = pathname.includes(marker) ? pathname.split(marker)[1] || "/home" : "/home";
  return `/workspace/${fallbackWorkspaceId}${suffix}`;
}
